// extracted by css-extract-rspack-plugin
export default {"body":"GY6K8"};